export default __webpack_public_path__ + "static/media/calendar.e48f96e1.png";